module.exports = __webpack_public_path__ + "img/37-s.c6d3e181.png";